var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"cfbc999f26a075f33842f271e195136dc9dbbfb6"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { Project } from './common/project'
import { CROSS_TENANT_NAVIGATION_ABORT } from './common/tenant'
import * as Sentry from '@sentry/nextjs'

if (Project.sentry && !__DEV__) {
  Sentry.init({
    dsn: Project.sentry,

    environment: Project.sentryEnvironment,

    // Expected: _app cancels client-side navigation between tenants by
    // throwing, then does a full page load. Not an error.
    ignoreErrors: [CROSS_TENANT_NAVIGATION_ABORT],

    // Error reporting only. Session Replay intentionally omitted to keep the
    // client bundle light on this SEO/perf-sensitive app.
    tracesSampleRate: 0,
  })
}
